import * as React from 'react';
import { AppConfigurationStore } from '../../stores/AppConfigurationStore';

export interface HamburgerContentWrapperProps extends React.Props<HTMLDivElement> {
    className: string;
    header: JSX.Element;
}

export const HamburgerContentWrapper: React.StatelessComponent<HamburgerContentWrapperProps> = (props: HamburgerContentWrapperProps) => {
    if (AppConfigurationStore.getState().inApp) {
        return (
            <div className={props.className}>
                {props.header}
                <div className="hamburger-tab-content scrollbar-wcf">
                    {props.children}
                </div>
            </div>
        );
    }

    return (
        <div className={props.className}>
            <div className="hamburger-tab-content scrollbar-wcf">
                {props.header}
                {props.children}
            </div>
        </div>
    );
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/hamburgermenu/HamburgerContentWrapper.tsx